<template>
    <a :class="{ 'deal-box-wrapper': !isGiftList }" @click="e => goToDeal(e, deal)" target="_blank" :href="dealLink"
        ref="dealbox">
        <div class="deal-box-giftlist" v-if="isGiftList">
            <div class="deal-box-number">#{{ index + 1 }}</div>
            <div class="deal-box-giftlist-img-container">
                <div v-if="!isDealVisible" class="blur-box shimmer"></div>
                <img v-if="isDealVisible" :src="deal.ImgUrl" :alt="deal.Title">
            </div>
            <div class="deal-box-giftlist-text-container">
                <div class="deal-box-giftlist-title">{{ deal.Title }}</div>
                <div class="deal-box-giftlist-desc">{{ deal.Description }}</div>
                <div class="deal-box-giftlist-btn"><button>Check it Out</button></div>
            </div>
        </div>

        <div class="deal-box-img-container" v-if="!isGiftList">
            <a class="deal-image-soldout" v-if="deal.isSoldOut">
                <img :src="`/Assets/img/soldout.png`" />
            </a>
            <div v-if="!isDealVisible" class="blur-box shimmer"></div>
            <img v-if="isDealVisible" class="deal-box-img" :src="deal.ImgUrl"
                :class="{ 'up-side-down': settings.purimMode }">
        </div>

        <div class="deal-box-desc" v-if="!isGiftList">
            {{ deal.Title }}
            <span v-if="isSimpleView && deal.PromoCode">
                <br />
                <div class="share-link-container share-link-container-dealbox">
                    <input id="promoCode" v-model="deal.PromoCode" class="promo-code-input promo-code-input-dealbox"
                        readonly />
                    <a v-show="!copied" class="promo-copy-code" @click="copyToClipboard($event)">COPY</a>
                    <a v-show="copied" class="promo-copy-code copied">COPIED</a>
                </div>
            </span>
        </div>
        <div :style="{ 'visibility': isDealNegativeOne || !showPrice ? 'hidden' : 'visible' }" v-if="showPrice">
            <div class="crossed-price"><span v-if='deal.RetailPrice'>{{ formatPrice(deal.RetailPrice) }}</span></div>
            <div class="deal-price-container">
                <div class="deal-price">{{ formatPrice(deal.DealPrice) }}</div>
                <div class="deal-discount" v-if="discount">-{{ discount.toFixed(0) }}%</div>
            </div>
        </div>
        <div v-if="!isGiftList" class="logo-img-container">
            <DealLogoImage :deal="deal" class="logo-img" />
        </div>
    </a>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import util from '@/helpers/util'
import settings from '@/settings'
import ga from '@/helpers/ga'
import clicky from '@/helpers/clicky'
import DealLogoImage from './DealLogoImage.vue'
import { DealDetails } from '@/classes/DealDetails'
import Cookies from 'js-cookie'
import { globalStore } from '@/stores/globalStore'
const props = defineProps<{
    deal: DealDetails
    index: number
    directLinks: boolean,
    showPrice: boolean
}>()

const route = useRoute()
const router = useRouter()
const dealbox = ref<HTMLElement | null>(null)
const dealLink = ref<string | null>(null)
const showTitle = ref(true)
const showDescription = ref(false)
const isGiftList = ref(false)
const isSimpleView = ref(false)
const copied = ref(false)
const isDealVisible = ref(false)

//SETUP
const $globalStore = globalStore()

//computed discount if there is a deal price and a retail price
const discount = computed(() => {
    return util.getDiscountPercentage(props.deal.DealPrice, props.deal.RetailPrice)
})

const isDealNegativeOne = computed(() => {
    return props.deal.DealPrice < 0
})

const formatPrice = (price: number): string => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(price)
}

const trackOutboundLink = (url: string): void => {
    ga.event('click', { 'event_category': 'outbound', 'event_label': url, 'transport_type': 'beacon' })
    clicky.goal('GiftClick')
}

const goToDeal = (event: Event, deal: DealDetails): void => {
    event.preventDefault()
    event.stopPropagation()

    console.log('deal', deal)

    //IF WE ARE ON MOBILE, OPEN THE MINI DEAL MODAL
    if (window.innerWidth < 768) {
        $globalStore.setSelectedDeal(deal, props.showPrice)
    }
    else {

        if (isGiftList.value) {
            trackOutboundLink(dealLink.value || '')
        }

        if (dealLink.value) {
            if (dealLink.value.startsWith('http')) {
                window.open(dealLink.value, '_blank')
            } else {
                router.push(dealLink.value)
            }
        }
    }


}

const copyToClipboard = (event: Event): void => {
    event.preventDefault()
    event.stopPropagation()
    const copyText = document.getElementById("promoCode") as HTMLInputElement
    if (copyText) {
        copyText.select()
        document.execCommand("copy")
        copied.value = true
        setTimeout(() => {
            copied.value = false
        }, 2000)
    }
}

onMounted(() => {
    //use jscookie
    const cookie_lastref = Cookies.get('MMD_LastRef')


    if (settings.siteName === 'fivetowncentral' || (cookie_lastref && cookie_lastref.toLowerCase() === '5townscentral')) {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', '5townscentral-20')
    }
    else if (settings.siteName === '5tcdeals') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', '5townscentral-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', '5tcdeals')
    }
    else if (settings.siteName === 'momazon' || (cookie_lastref && cookie_lastref.toLowerCase() === 'adir')) {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'adirdeals-20')
    }
    else if (settings.siteName === 'alyssagoldwater' || (cookie_lastref && cookie_lastref.toLowerCase() === 'alyssagoldwater')) {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'agoldwater-20')
    }
    else if (cookie_lastref && cookie_lastref.toLowerCase() === 'mmdfriedman') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'mmdfriedman-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'moshe')
    }
    else if (cookie_lastref && cookie_lastref.toLowerCase() === 'klugman') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', '18ventures-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'klugman')
    }
    else if (cookie_lastref && cookie_lastref.toLowerCase() === 'dovidklugman') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'mmdbraum-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'dovidklugman')
    }
    else if (cookie_lastref && cookie_lastref.toLowerCase() === 'braum') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'mmdbraum-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'braum')
    }
    else if (cookie_lastref && cookie_lastref.toLowerCase() === 'tempelberg') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'tempelberg-20')
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'tempelberg')
    }
    else if (settings.siteName === 'mommydeals' && props.deal.DealProvider === 'Amazon') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'mommydeals0a-20')
    }
    else if (settings.siteName === 'mommydeals' && props.deal.DealProvider === 'Walmart') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'mommydeals')
    }
    else if (settings.siteName === 'petpetdeals' && props.deal.DealProvider === 'Amazon') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'petpetdeals-20')
    }
    else if (settings.siteName === 'petpetdeals' && props.deal.DealProvider === 'Walmart') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'petpetdeals')
    }
    else if (settings.siteName === 'chaideals' && props.deal.DealProvider === 'Amazon') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'tag', 'chaideals-20')
    }
    else if (settings.siteName === 'chaideals' && props.deal.DealProvider === 'Walmart') {
        props.deal.DealURL = util.replaceOrAddUrlParam(props.deal.DealURL, 'sharedid', 'chaideals')
    }

    if (route.name === 'giftideas' || route.name === 'giftlist' || route.name === 'giftlist2') {
        isGiftList.value = true
        dealLink.value = props.deal.DealURL
    }
    else {
        isGiftList.value = false


        if (props.directLinks) {
            dealLink.value = props.deal.DealURL;
        }
        else if (route.query.direct) {
            isSimpleView.value = true
            dealLink.value = props.deal.DealURL;
        }
        else {
            isSimpleView.value = false
            dealLink.value = '/Deal/' + props.deal.DealID + '/' + props.deal.PrettyTitle
        }
    }

    if (dealbox.value) {
        util.doSomethingOnceVisible(dealbox.value, () => { isDealVisible.value = true })
    }
})
</script>

<style scoped>
.deal-box-desc {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    /* Limit to 3 lines */
    -webkit-box-orient: vertical;
    overflow: hidden;
}
</style>
